module.exports = __webpack_public_path__ + "static/img/illustration.3f201a6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/cognitive/illustration.png
// module id = vDYt
// module chunks = 0